// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-grid-percent-complete-bar-column[data-v-06cbc0de]{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
